export default {
  marginElement: { width: '10px' },
  menuItem: {
    cursor: 'pointer',
    borderRadius: '8px',
    gap: '2px',
    display: 'flex',
    fontSize: '14px',
    padding: '4px 0px',
    justifyContent: 'flex-start',
    position: 'relative',
    color: '#2E2E30',
  },
  menuItemInner: {
    gap: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};
